// RouteGuard.tsx

import React from "react";
import { LoaderComponentProps, withLoader } from "../AppComponents/Loader";
import { ProtectedAccessDeniedPage } from "../AppComponents/ProtectedComponents";
import useRolesPermissionsAccess from "../Hooks/useRolesPermissionsAccess";
import { useAppSelector } from "../Store";
import { useAuthStore } from "../Store/Slices/AuthSlice";
import { isEmptyObject } from "../Utils";
import { Navigate, useLocation } from "react-router-dom";

const ONBOARDING_PATHS = ["/onboarding", "/onboarding/welcome", "/onboarding/1", "/onboarding/4" ,"/onboarding/3","/subscription/subscription-plans/plans","/subscription/subscription-plans","/subscription","/subscription/subscription-plans/details"];

interface RouteGuardProps extends LoaderComponentProps {
  moduleId: string;
  element: React.ReactElement<any>;
}

const RouteGuard: React.FC<RouteGuardProps> = ({
  moduleId,
  element,
  setLoading,
}) => {
  const { userConfig } = useAppSelector(useAuthStore);
  const { isValidAccess, isContentReady } = useRolesPermissionsAccess(moduleId);
  const isWhatsappConfigured = userConfig?.payload?.whatsapp_enabled ?? false;
  const location = useLocation();

  React.useEffect(() => {
    if (!isContentReady) {
      setLoading(false);
    }
  }, [isContentReady]); // eslint-disable-line react-hooks/exhaustive-deps

  if (
    !moduleId ||
    !userConfig ||
    isEmptyObject(userConfig?.payload?.allowed_permissions)
  )
    return null;

  if (!isContentReady) return null; // using this approach to avoid flickering of 404 page

  if (isContentReady && !isValidAccess) {
    return <ProtectedAccessDeniedPage />;
  }
  
  if (isContentReady && !isWhatsappConfigured && !ONBOARDING_PATHS.includes(location.pathname)) {    
    return <Navigate replace to="/onboarding/welcome" />;
   }

  return element;
};

export default withLoader(RouteGuard);
